import React from 'react';
import CountUp from 'react-countup';

import Fa1 from '../../images/funfact/s1.png'
import Fa2 from '../../images/funfact/s2.png'
import FaIcon1 from '../../images/funfact/1.svg'
import FaIcon2 from '../../images/funfact/2.svg'
import FaIcon3 from '../../images/funfact/3.svg'
import FaIcon4 from '../../images/funfact/4.svg'

const FunFact = (props) => {

    return (
        <section className={"" + props.hclass}>
            <div className="f-shape-1"><img src={Fa1} alt=""/></div>
            <div className="f-shape-2"><img src={Fa2} alt=""/></div>
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="orico-fun-fact-grids clearfix">
                            <div className="grid">
                                <div className="info">
                                    <p className='text-white fs-2'>Trusted By Customers</p>
                                    <div className="icon">
                                        {/* <img src={FaIcon1} alt=""/> */}
                                    </div>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="info">
                                    
                                    <p className='text-white fs-2'>free delivery</p>
                                    <div className="icon">
                                        {/* <img src={FaIcon2} alt=""/> */}
                                    </div>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="info">
                                    
                                    <p className='text-white fs-2'>24/7 support </p>
                                    <div className="icon">
                                        {/* <img src={FaIcon3} alt=""/> */}
                                    </div>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="info">
                                
                                    <p className='text-white fs-2'> Money transfer</p>
                                    <div className="icon">
                                        {/* <img src={FaIcon4} alt=""/> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </section>
    )

}

export default FunFact;